import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { CustomElement } from "@cervval.js/client-html5-spa/navigation";
import { CjsTabs, TabElement } from "@cervval.js/client-html5-ui/src/components/tabs/tabs";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { ensureLoaded } from "@cervval.js/common/src/tools/object.tools";
import { BookingCalendar, BookingWeek } from "@ehealth_tools/common-booking/src/data/booking.dto";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { AbstractClientBookingService } from "../../../../../../services/abstractClientBooking.service";
import { CalendarException } from "../calendarException/calendarException.component";
import { TypicalWeek } from "../typicalWeek/typicalWeek.component";
import { I18n, I18nCalendarDisplay } from "./calendarDisplay.component.i18n";

ensureLoaded(CjsTabs);
ensureLoaded(TypicalWeek);
ensureLoaded(CalendarException);

@CustomElement({
    name: "calendar-display",
    style: require("./calendarDisplay.component.scss"),
    template: require("./calendarDisplay.component.html"),
    i18n: require("./calendarDisplay.component.i18n")
})
export class CalendarDisplay extends WebComponent<I18nCalendarDisplay> {
    @TypedHtmlElements()
    private _components!: {
        typicalWeek: TypicalWeek,
        calendarException: CalendarException
    };

    @Injected(BOOKING_SERVICE)
    private _bookingService!: AbstractClientBookingService;

    private _tabs: CjsTabs | undefined;

    /** Init Component */
    public override init(): void {
        const tabElements: TabElement[] = [{
            uid: this.componentNumber + "_typicalWeek",
            label: I18n().typicalWeek,
            tabContent: {
                content: this._components.typicalWeek
            }
        }, {
            uid: this.componentNumber + "_exceptions",
            label: I18n().exceptions,
            tabContent: {
                content: this._components.calendarException
            }
        }];
        this._tabs = new CjsTabs();
        this.prepend(this._tabs);
        this._tabs.setData(tabElements);
    }

    /** */
    public selectCalendar(calendar: BookingCalendar): void {
        const week = this._bookingService.getById<BookingWeek>("bookingWeeks", calendar.defaultWeekId);
        this._components.typicalWeek.options.setAndRefreshIfChanged({ currentWeek: week });
        this._components.calendarException.options.setAndRefreshIfChanged({ currentCalendar: calendar });
    }

    /** Refresh component */
    public override refresh(): void {
        if (this._tabs) {
            this._tabs.refresh();
        }
        this._components.typicalWeek.refresh();
        this._components.calendarException.refresh();
    }
}